import * as routes from 'router/routes';

const FULL_WIDTH_ROUTES = [routes.actionTracker, routes.organisationOverview];

export const checkIsFullWidthPage = (pathname) => FULL_WIDTH_ROUTES.some((route) => pathname.startsWith(route));
